<template>
  <div>

  <nav class="navbar am-navbar navbar-expand-lg navbar-expand-lg py-0 align-items-center">
    <div class="collapse navbar-collapse align-items-center">
      <ul class="navbar-nav am-home-menu">
        <li class="nav-item">
          <old-link class="nav-link" to="#/home">Home</old-link>
        </li>
        <!--Office-->
        <li class="navbar-spacing" v-if="hasPermission('PROfficeTab')"></li>
        <li class="nav-item" v-if="hasPermission('PROfficeTab')">
          <div class="btn-group">
            <old-link class="nav-link" to="#/profile">Office(Off)</old-link>
          </div>
        </li>
        <li class="nav-item" v-if="hasPermission('PROfficeTab') && hasConfigPermission('officeTabDropdown')">
          <div class="am-dropdown" v-if="$store.state.auth.permissions.PRshowOfficeMenuDropdown">
            <a class="nav-link dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
            <header-drop-down :items="data.office"></header-drop-down>
          </div>
        </li>

        <!--Forms-->
        <li class="navbar-spacing"></li>
        <li class="nav-item">
          <old-link class="nav-link" to="#/forms">Forms</old-link>
        </li>

        <!--Rolodex-->
        <li class="navbar-spacing" v-if="hasPermission('PRRolodexTab')"></li>
        <li class="nav-item" v-if="hasPermission('PRRolodexTab')">
          <old-link class="nav-link" to="#/rolodex">Rolodex</old-link>
        </li>

        <!--End Of Day-->
        <li class="navbar-spacing" v-if="hasPermission('PRviewEOD')"></li>
        <li class="nav-item" v-if="hasPermission('PRviewEOD')">
          <old-link class="nav-link" to="#/eod">E.O.D</old-link>
        </li>

        <!--Reports-->
        <li class="navbar-spacing"></li>
        <li class="nav-item">
          <old-link class="nav-link" to="#/reports">Reports</old-link>
        </li>
        <li class="nav-item" v-if="hasConfigPermission('reportTabDropdown')">
          <div class="am-dropdown" v-if="$store.state.auth.permissions.PRshowReportsMenuDropdown">
            <a class="nav-link dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
            <header-drop-down :items="data.report"></header-drop-down>
          </div>
        </li>

        <!--Dashboard-->
        <li class="navbar-spacing" v-if="hasPermission('dashboardView')"></li>
        <li class="nav-item" v-if="hasPermission('dashboardView')">
          <old-link class="nav-link" to="/dashboard.php">Dashboard</old-link>
        </li>

        <!--Admin-->
        <li class="navbar-spacing"></li>
        <li class="nav-item">
          <old-link class="nav-link" to="#/admin">Admin</old-link>
        </li>
        <li class="nav-item" v-if="hasConfigPermission('adminTabDropdown')">
          <div class="am-dropdown" v-if="$store.state.auth.permissions.PRshowAdminMenuDropdown">
            <a class="nav-link dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
            <header-drop-down :items="data.admin"></header-drop-down>
          </div>
        </li>

        <!--Training-->
        <li class="navbar-spacing" v-if="hasPermission('PRtraining')"></li>
        <li class="nav-item" v-if="hasPermission('PRtraining')">
            <a class="nav-link" href="/training">Training</a>
        </li>

        <!--Leads-->
        <li class="navbar-spacing" v-if="hasConfigPermission('isReceiveLeads') && hasPermission('PRLeadsTab')"></li>
        <li class="nav-item"  v-if="hasConfigPermission('isReceiveLeads') && hasPermission('PRLeadsTab')">
          <old-link class="nav-link" to="#/leads">Leads</old-link>
        </li>
        <li class="nav-item"  v-if="hasConfigPermission('isReceiveLeads') && hasPermission('PRLeadsTab') && hasConfigPermission('leadsTabDropdown')">
          <div class="am-dropdown">
            <a class="nav-link dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
            <ul class="dropdown-menu">
              <li><old-link class="dropdown-item" to="#/leads/new">New Leads</old-link></li>
              <li><old-link class="dropdown-item" to="#/leads/open">Open Leads</old-link></li>
              <li><old-link class="dropdown-item" to="#/leads/sold">Sold Leads</old-link></li>
              <li><old-link class="dropdown-item" to="#/leads/closed">Closed Leads</old-link></li>
              <li v-if="$store.state.auth.permissions.PRLeadViewIncubateTab || $store.state.auth.permissions.PRadmin"><old-link class="dropdown-item" to="#/leads/Incubate">Incubate</old-link></li>
              <li v-if="$store.state.auth.permissions.PRLeadViewUnassignedTab || $store.state.auth.permissions.PRadmin"><old-link class="dropdown-item" to="#/leads/unassigned">Un-Assigned Leads</old-link></li>
              <li v-if="$store.state.auth.permissions.PRLeadViewCallCenterTab"><old-link class="dropdown-item" to="#/leads/CallCenter">Call Center</old-link></li>
              <li><old-link class="dropdown-item" to="#/leads/snapshot">Snapshot</old-link></li>
              <li><old-link class="dropdown-item" to="#/leads/stats">Stats</old-link></li>
              <li><old-link class="dropdown-item" to="#/leads/lookup">Lookup</old-link></li>
              <li><old-link class="dropdown-item" to="#/leads/log">Activity Log</old-link></li>
              <li><old-link class="dropdown-item" to="#/leads/tasks">Tasks</old-link></li>
            </ul>
          </div>
        </li>

        <!--Rater-->
        <li class="navbar-spacing" v-if="hasPermission('agencyMatrixRaterAddOn') && hasConfigPermission('isEnabledRaterTab')"></li>
        <li class="nav-item" v-if="hasPermission('agencyMatrixRaterAddOn') && hasConfigPermission('isEnabledRaterTab')"><a class="nav-link" @click="$modal.show('raterModal')">Rater</a></li>

        <!--Back Office-->
        <li class="navbar-spacing" v-if="hasBackOffice()"></li>
        <li class="nav-item" v-if="hasBackOffice()">
          <old-link class="nav-link" to="#/backofficeTab">Back Office</old-link>
        </li>

        <!--File Locker-->
        <li class="navbar-spacing" v-if="getLiteSwitch() >= 4 && hasPermission('PRFileLockerTab')"></li>
        <li class="nav-item" v-if="getLiteSwitch() >= 4 && hasPermission('PRFileLockerTab')">
          <old-link class="nav-link" to="#/fileLocker">File Locker</old-link>
        </li>
      </ul>

      <div class="form-inline mr-auto">
        <back-office-search v-if="hasBackOffice()"></back-office-search>
      </div>
      <div v-if="!$store.state.auth.agreementVersion.isAgreementRequired">
        <notification></notification>
      </div>
    </div>
    <modal name="raterModal" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3" height="150px" width="370px">
        <div class="am-rater-title-bar am-main-top-box">
          <span class="am-rater-title-bar am-main-top-box-title"><strong>Rater</strong></span>
          <div class="am-rater-close">
            <font-awesome-icon class="am-rater-circle" icon="times-circle" @click="closeRater()" title="Close Rater"/>
          </div>
        </div>
      <div class="text-center">
        <table class="am-rater-table">
          <tbody>
          <tr>
            <td>
              <old-link class="btn btn-primary btn-sm" to="#/raters/itc/iframe/0/0/0/1">New Quote</old-link>
            </td>
            <td>
              <old-link class="btn btn-primary btn-sm" to="#/customer/search?selection=quote&amp;query=">Stored Quotes</old-link>
            </td>
          </tr>
          </tbody>
        </table>

        <div slot="modal-footer"></div>
      </div>
    </modal>
  </nav>
  </div>

</template>

<script>
import OldLink from '@/components/OldLink'
import BackOfficeSearch from '@/components/BackOfficeSearch'
import HeaderDropDown from '@/components/HeaderDropDown'
import Notification from '@/components/Notification'
import api from './../http'
import config from './../config/global.config'
import helper from '@/mixins/helper'
import localStorage from '@/config/global.localStorage'

export default {
  components: {
    OldLink,
    BackOfficeSearch,
    HeaderDropDown,
    Notification
  },

  mixins: [helper],

  asyncComputed: {
    data: {
      get () {
        return localStorage.getUrl('/scripts/app/jsonRoutes.php');
      },
      default: {
        'report': [],
        'training': [],
        'admin': [],
        'offices': []
      }
    }
  },

  methods: {
    closeRater () {
      this.$modal.hide('raterModal')
    }
  }
}
</script>
<style scoped>
  .am-home-menu {
    font-weight: 600;
    font-size: 11.5px;
  }

  .am-home-menu .navbar-spacing{
    background: inherit;
    width: 1px;
  }

  .am-navbar{
    padding-left: 12px;
    padding-right: 12px;
  }

  .nav-item {
    padding: 1px;
  }

  .am-rater-title-bar {
    height: 35px;
    padding: 2px 0px 0px 5px;
  }
  .am-rater-close {
   padding:  2px 5px 0px 0px;
    float: right
  }
  .am-rater-table {
    margin: auto; margin-top: 10%;
  }
  .am-rater-table td {
    padding: 5px;
  }
 .am-rater-circle {
   color: black;
   cursor: pointer;
 }

</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
